<sis-tiny-badge *ngIf="badgeVariant" [variant]="badgeVariant" class="flow-state">
    <span>{{translationKey | translate}}</span>
    <span *ngIf="publishDate && flowState === 'PUBLISHED'">&nbsp;{{publishDate | localDateFormat}}</span>
</sis-tiny-badge>
